import styled from 'styled-components'

const Boton = styled.div`
    text-transform: uppercase;
    font-size: 12px;
    border: none;
    color: #fff;
    background: #08b354;
    border-radius: 4px;
    letter-spacing: 1px;
    transition: 200ms ease-in-out;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 8px;
    padding-right: 8px;
    margin-left: 1.1rem;

    &:hover {
        background: #89d9ad;
        color: #0f8d47;
        transition: 200ms ease-in-out;
    }
`

const BotonFetching = styled.div`
    text-transform: uppercase;
    font-size: 12px;
    border: none;
    color: #0f8d47;
    background: #89d9ad;
    border-radius: 4px;
    letter-spacing: 1px;
    cursor: default;
    display: inline-flex;
    align-items: center;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 8px;
    padding-right: 8px;
    margin-left: 1.1rem;
`

export {
    Boton,
    BotonFetching
}